module.exports = "<app-sidebar></app-sidebar>\n<div class=\"dashcontainer\" [ngClass]=\"{active: !toggle.hidelogo}\">\n    <app-header></app-header>\n    <div class=\"space80\">\n        <ng4-loading-spinner [template]=\"_template\"></ng4-loading-spinner>\n        <router-outlet></router-outlet>\n    </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/layouts/full-layout.component.html
// module id = ./src/app/layouts/full-layout.component.html
// module chunks = main